import React from "react";
import { UserApi } from "@features/shared/api/course-data.api";

export type UserCountryCodeState = {
    countryCode: string;
    isLoading: boolean;
};

export const useUserCountryCode = (): UserCountryCodeState => {
    const [countryCode, setCountryCode] = React.useState("");
    const [isLoading, setIsLoading] = React.useState(true);

    React.useEffect(() => {
        let ignore = false;

        (async () => {
            try {
                const location = await UserApi.getUserLocation();
                if (!ignore) {
                    setCountryCode(location?.country ?? "");
                    setIsLoading(false);
                }
            } catch {
                if (!ignore) {
                    setCountryCode("");
                    setIsLoading(false);
                }
            }
        })();

        return () => {
            ignore = true;
        };
    }, []);

    return { countryCode, isLoading };
};
